import { UseMutationOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  ExportContactsMutation,
  ExportContactsMutationVariables,
} from "../../../generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../useGraphQlClient";

const exportContacts = graphql(`
  mutation exportContacts(
    $filters: SearchContactsRequest!
    $exportFormat: ExportFormatArgs!
    $selectedContacts: SelectedContacts!
  ) {
    exportContacts(
      SearchContactsRequest: $filters
      ExportFormat: $exportFormat
      SelectedContacts: $selectedContacts
    ) {
      id
    }
  }
`);

export function useContactExport(
  options?: UseMutationOptions<
    ExportContactsMutation,
    unknown,
    ExportContactsMutationVariables,
    unknown
  >,
) {
  const { data, ...rest } = useGraphQlMutation(exportContacts, options);
  return { ...rest, data: data?.exportContacts };
}
